import { render, staticRenderFns } from "./AsideMenuList.vue?vue&type=template&id=5be23516&"
import script from "./AsideMenuList.vue?vue&type=script&lang=js&"
export * from "./AsideMenuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\www\\aliventa\\gruene-hex\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5be23516')) {
      api.createRecord('5be23516', component.options)
    } else {
      api.reload('5be23516', component.options)
    }
    module.hot.accept("./AsideMenuList.vue?vue&type=template&id=5be23516&", function () {
      api.rerender('5be23516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AsideMenuList.vue"
export default component.exports